<template>
    <div class="page-wrapper bg-white radius-lg margin-left-sm flex flex-direction padding">
        <div class="flex align-center">
            <div class="status flex-sub flex flex-direction justify-center align-center">
                <el-button :disabled="readonly" type="text" @click="ruleForm.check_status = 1">
                    <i :class="ruleForm.check_status === 1 ? 'text-orange active' : 'text-black'" class="check el-icon-check"></i>
                </el-button>
                <div class="text-df text-black text-bold margin-bottom-sm">正常结项</div>
                <div class="flex align-center">
                    <upload-file name="zc_file" :disabled="readonly">
                        <el-button slot="upload" class="btn max radius bg-orange" size="small" type="warning">
                            上传项目验收单
                        </el-button>
                    </upload-file>
                    <div v-if="zc_file  && ruleForm.check_status === 1">
<!--                        <el-link :href="zc_file.url" class="margin-left-sm" target="_blank">{{ zc_file.name }}</el-link>-->
                        <div class="file-name margin-left-sm cursor" @click="toFilePreview(zc_file.name,zc_file.url)">{{ zc_file.name }}</div>
                    </div>
                </div>
            </div>
            <div class="status flex-sub flex flex-direction justify-center align-center margin-left">
                <el-button :disabled="readonly" type="text" @click="ruleForm.check_status = 2">
                    <i :class="ruleForm.check_status === 2 ? 'text-orange active' : 'text-black'" class="check el-icon-check"></i>
                </el-button>
                <div class="text-df text-black text-bold margin-bottom-sm">非正常结项</div>
                <div class="flex align-center">
                    <upload-file name="fzc_file" :disabled="readonly" @uploadFile="uploadFile">
                        <el-button slot="upload" class="btn max radius bg-orange" size="small" type="warning">
                            上传结项说明
                        </el-button>
                    </upload-file>
                    <div v-if="fzc_file && ruleForm.check_status === 2">
                        <div class="file-name margin-left-sm cursor" @click="toFilePreview(fzc_file.name,fzc_file.url)">{{ fzc_file.name }}</div>
<!--                        <el-link :href="fzc_file.url" class="margin-left-sm" target="_blank">{{ fzc_file.name }}-->
<!--                        </el-link>-->
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!readonly" class="flex justify-center margin-top-xl">
            <el-button :loading="requesting" class="btn max" type="primary" @click="submitInfo">
                保存
            </el-button>
        </div>
    </div>
</template>

<script>

import {TOAST, toast, toFilePreview} from "@/utils/utils";
import {addProjectPost} from "@/api";
import UploadFile from "@/views/web/components/UploadFile";

export default {
    components: {UploadFile},
    name: "ProjectPost",
    data() {
        return {
            zc_file: '',
            fzc_file: '',
            ruleForm: {
                check_status: '',
            },
            rules: {
                mid: [
                    {required: true, message: '请输入成员', trigger: 'change'}
                ]
            },
            requesting: false,
        }
    },
    props: {
        detail: {
            type: Object
        },
        pid: {
            type: Number,
            default: 0
        },
        readonly: {
            type: Boolean,
            default: false
        },
    },
    computed: {},
    created() {
        if (this.detail) this.setData()
    },
    methods: {
        async submitInfo() {
            if (!this.ruleForm.check_status) return toast('请选择结项状态', TOAST.error)
            if (this.ruleForm.check_status === 1 ? !this.zc_file : !this.fzc_file) return toast(`请上传${this.ruleForm.check_status === 1 ? '上传项目验收单' : '上传结项说明'}`, TOAST.error)
            this.requesting = true
            let _data = await addProjectPost(this.pid, this.ruleForm.check_status, this.ruleForm.check_status === 1 ? JSON.stringify(this.zc_file) : JSON.stringify(this.fzc_file))
            if (_data.status === 200) {
                this.$emit('watchState', true)
                toast('验收结项成功', TOAST.success)
            } else {
                toast(_data.msg, TOAST.error)
            }
            this.requesting = false
        },
        //  上传成功
        uploadFile(data) {
            this[data.name] = {
                name: data.file.name,
                url: data.file.url
            }
            this.ruleForm.check_status = data.name === 'zc_file' ? 1 : 2
        },
        setData() {
            this.ruleForm = {
                check_status: this.detail.check_status,
            }
            if (this.ruleForm.check_status === 1) {
                this.zc_file = this.detail.check_file ? JSON.parse(this.detail.check_file) : ''
            } else {
                this.fzc_file = this.detail.check_file ? JSON.parse(this.detail.check_file) : ''
            }
        },
        toFilePreview(name,url){
            toFilePreview(name,url)
        }
    },
    watch: {
        detail() {
            if (this.detail) this.setData()
        }
    }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .status {
        height: 177px;
        background-color: #ffffff;
        border-radius: 10px;
        border: solid 1px #e6e6e6;
        position: relative;

        .check {
            position: absolute;
            top: 15px;
            left: 15px;
            cursor: pointer;
            font-size: 22px;
            border: solid 1px #333;
            padding: 2px;

            &.active {
                border: solid 1px var(--orange);
            }
        }
    }

}
</style>